import React, { useState, useEffect } from "react";
import { Form, Card, Spinner } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import * as authActions from "../../../redux/actions/authAction";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const ForgetPassword = () => {
  const dispatch = useDispatch();
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [apiCall, setApiCall] = useState(false);

  const forgetPasswordToken = useSelector((state) => state.authentication);

  const handleSubmitForm = (e) => {
    e.preventDefault();

    if (!isValidEmail(email)) {
      setEmailError("Please enter a valid email");
      return;
    }    
    setEmailError("");

    const obj = { email: email.trim() };
    setApiCall(true);
    setIsLoading(true);
    dispatch(authActions.userForgetPasswordRequest(obj, callback));
  };

  const isValidEmail = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };
  
  const callback = () => {
    setIsLoading(false);
  };

  useEffect(() => {
    if (!apiCall) return;

    const handleResponse = async () => {
      if (!apiCall || !forgetPasswordToken) return;
      if (forgetPasswordToken.status === 200) {
        if (forgetPasswordToken?.data?.token) {
          localStorage.setItem(
            "user",
            email
          );
          toast.success("Your password reset code has been sent");
          setTimeout(() => {
            window.location.href = "/reset-password";
          }, 1600);

        } else {
          toast.error("An error occurred");
        }
      }

      if (forgetPasswordToken.error) {
        toast.error(forgetPasswordToken.message || "Error sending code");
      }
    };

    handleResponse();
  }, [forgetPasswordToken, apiCall]);

  return (
    <>
      <div className="forget-password">
        <div className="text-center my-3">
          <img src="/img/logo@2x.png" className="img-fluid" alt="logo" />
        </div>
        <div className="background-screen">
          <div className="d-grid justify-content-center align-items-center h-100">
            <Card>
              <Card.Body className="mx-5 my-5">
                <h3 className="text-center mb-4 font-weight-bold">
                  Forgot Password
                </h3>
                <p>Please enter your email address to receive a verification code</p>
                <Form onSubmit={handleSubmitForm}>
                  <Form.Group className="mb-4" controlId="formBasicEmail">
                    <Form.Label>Email Address</Form.Label>
                    <Form.Control
                      type="email"
                      placeholder="Enter email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      isInvalid={!!emailError}
                      required
                    />
                    <Form.Control.Feedback type="invalid">
                      {emailError}
                    </Form.Control.Feedback>
                  </Form.Group>

                  <div className="text-center">
                    {isLoading ? (
                      <button className="btn-login btn-lg" disabled>
                        <Spinner
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                        />
                      </button>
                    ) : (
                      <button type="submit" className="btn-login btn-lg">
                        Send
                      </button>
                    )}
                  </div>
                </Form>
              </Card.Body>
            </Card>
            <p className="text-center text-white mt-3">
              &copy; 2022 EQWELL ~ All Rights Reserved.
            </p>
          </div>
        </div>
      </div>
      <ToastContainer />
    </>
  );
};

export default ForgetPassword;
